import { Box } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import ModalComp from "./ModalComp";

export default function HomeHelpHeartPoint({ children }) {
  const swiperPage = [
    {
      text: `
				 운동 중 심박밴드를 통하여 측정한 심박포인트가 100포인트에 도닳게 되면 스탬프가 지급되며
				 스탬프를 터치하여 캐시를 지급 받을 수 있습니다.
			`,
    },
    {
      text: `
				 두써킷에서 받은 캐시는 클래스 쿠폰 구매 시 현금처럼 사용할 수 있습니다.
			`,
    },
    {
      text: `
				 하트는 100캐시이며 하트 5개를 모으면 코인(500캐시)이 추가로 지급 됩니다. <br />
				 하트를 120개 모으면 10,000캐시를 지급 받을 수 있삽니다. <br />
         10,000 캐시는 최대 3회 까지만 받을 수 있습니다.
			`,
    },
    {
      text: `
				 상단 화면을 통하여 현재까지 지급받은 스탬프 갯수를 확인할 수 있습니다.
			`,
    },
    {
      text: `
				 캐시 지급 내역은 홈 화면에서 캐시를 선택하시면 확인할 수 있습니다.
			`,
    },
    {
      text: `
				 두써킷 프로그램을 통하여 측정된 심박수는 질병진단이나 치료 행위 등의 의료 목적으로 사용할 수
				 없습니다. 심박포인트(심박시스템)는 하기 내용으로 특허를 받았습니다. 이를 무단복제하는 경우,
				 법적 조치가 들어갈 수 있으므로 유의해주시기 바랍니다.
			`,
    },
  ];
  return (
    <>
      <ModalComp button={<div>{children}</div>} title="심박포인트 안내" divider>
        <Swiper
          // slidesOffsetBefore={24}
          // slidesOffsetAfter={24}
          grabCursor={true}
          slidesPerView={1}
          className="mySwiper"
          pagination={{ clickable: true }}
          style={{
            width: "100%",
            height: "100%",
            zIndex: "1",
            swiperSwiperPaginationBulletsBullets: {
              bottom: 0,
            },
          }}
        >
          {swiperPage.map((swiper, index) => (
            <SwiperSlide key={index}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  height: "100%",
                }}
              >
                <Box
                  sx={{
                    margin: "20px",
                    padding: "20px",
                    borderRadius: "5px",
                  }}
                >
                  <Box
                    sx={{
                      fontSize: "14px",
                    }}
                  >
                    <Box dangerouslySetInnerHTML={{ __html: swiper.text }} />
                  </Box>
                </Box>
                <Box
                  sx={{
                    width: "100%",
                    textAlign: "center",
                    justifyContent: "center",
                    display: "flex",
                    flex: "1",
                    paddingBottom: "2rem",
                  }}
                >
                  <img
                    src={`/img/heart_point/helper/heartpoint_help0${
                      +index + 1
                    }.png`}
                    style={{
                      objectFit: "contain",
                    }}
                  />
                </Box>
              </Box>
            </SwiperSlide>
          ))}
        </Swiper>
      </ModalComp>
    </>
  );
}
